export default __webpack_public_path__ + "assets/d22d78aae75b6097ef97865bed1add5e.png";